<template>
  <div>
    <v-toolbar
      color="blue-grey"
      dark
      tabs
    >
      <v-toolbar-title>วิทยาเขต/คณะ/ภาควิชา</v-toolbar-title>

      <v-tabs
        slot="extension"
        v-model="model"
        centered
        color="blue-grey"
        slider-color="yellow"
      >
        <v-tab
          v-for="i in tabItems"
          :key="i.key"
          :href="`#${i.key}`"
        >
          {{ i.text }}
        </v-tab>
      </v-tabs>
    </v-toolbar>

    <v-tabs-items v-model="model">
      <v-tab-item
        v-for="i in tabItems"
        :value="`${i.key}`"
        :key="i.key"
      >
        <v-card flat>
          <v-card-text>
            <component :is="i.key"></component>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import CampusDataTable from './dataTables/campus.vue'
import FacultyDataTable from './dataTables/faculty.vue'
import DepartmentDataTable from './dataTables/department.vue'

export default {
  components: {
    CampusDataTable,
    FacultyDataTable,
    DepartmentDataTable
  },
  data () {
    return {
      currentView: null,
      model: 'campus-data-table',
      tabItems: [
        { key: 'campus-data-table', text: 'วิทยาเขต' },
        { key: 'faculty-data-table', text: 'คณะ' },
        { key: 'department-data-table', text: 'ภาควิชา' }
      ]
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/settings/campus/index.vue